// src/components/ProtectedRoute.jsx
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { auth } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";
import { hasPermission, isAdminRole } from "../config/permissions";

/**
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @param {string[]} [props.allowedRoles] — legacy: require one of these roles
 * @param {string | string[]} [props.requirePermission] — one permission id, or any id from the list
 */
export default function ProtectedRoute({ children, allowedRoles, requirePermission }) {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u);
      setLoading(false);
    });
    return () => unsub();
  }, []);

  if (loading) return <div>Checking auth...</div>;
  if (!user) return <Navigate to="/login" replace />;

  const saved = JSON.parse(localStorage.getItem("user") || "{}");
  const role = saved?.role || "viewer";

  if (allowedRoles) {
    const ok = allowedRoles.some((allowed) => {
      const a = String(allowed).toLowerCase();
      if (a === "admin") return isAdminRole(role);
      return String(role).toLowerCase() === a;
    });
    if (!ok) {
      return (
        <div className="p-6 text-center text-slate-700">
          Access denied — your role does not allow this page.
        </div>
      );
    }
  }

  const permissionIds = requirePermission
    ? Array.isArray(requirePermission)
      ? requirePermission
      : [requirePermission]
    : [];
  const hasRequiredPermission =
    !permissionIds.length || permissionIds.some((id) => hasPermission(saved, id));

  if (!hasRequiredPermission) {
    return (
      <div className="p-6 text-center text-slate-700">
        Access denied — you do not have permission for this area. Ask an administrator to update your access in Admin
        panel.
      </div>
    );
  }

  return children;
}
